import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/machine/fault`,
    name: 'MACHINE_FAULT_POST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
